import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import { useUser, useAudio } from "@/app/store"
import { ArrowUpRightIcon, QuestionMarkCircleIcon } from "@heroicons/react/20/solid"
// import Intro from "@/app/(pages)/(home)/(components)/Intro"
import Button from "@/app/components/Button"
import iconStore from "@/app/assets/images/icon/store.png"
import iconScan from "@/app/assets/images/icon/scan.png"


export default function Links() {

    const router = useRouter()
    const user = useUser().data
    const audio = useAudio()
    const records = user.attraction_cards.filter((c: any) => c.created_at)
    const [ popup, setPopup ] = useState(null)

    useEffect(() => {
        router.prefetch('/scan')
        router.prefetch('/shop')
        router.prefetch('/routes')
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <div className="flex gap-2 whitespace-nowrap">
                <Button
                    className="flex items-center gap-2 p-3 bg-white rounded-[1rem] w-full shadow"
                    onClick={() => {router.push('/scan')}}
                >
                    <img src={iconScan.src} className="w-[3rem] aspect-square" />
                    <div className="text-[1.125rem] text-main-600 font-bold">
                        開始探索
                    </div>
                </Button>
                <Button
                    className="flex items-center gap-2 p-3 bg-white rounded-[1rem] w-full shadow"
                    onClick={() => {router.push('/shop')}}
                >
                    <img src={iconStore.src} className="w-[3rem] aspect-square" />
                    <div className="text-[1.125rem] text-main-600 font-bold">
                        好玩點商店
                    </div>
                </Button>
            </div>
            <Button
                className="p-4 bg-white rounded-[1rem] w-full shadow space-y-2"
                onClick={() => {router.push('/routes')}}
            >
                <div className="flex-center justify-between">
                    <div className="text-[1.125rem] font-bold">
                        <span className="text-secondary">
                            {user.account.name + ' '}
                        </span>
                        <span className="text-main-600">
                            的景點卡護照
                        </span>
                    </div>
                    {/* <div onClick={(e) => {
                        e.stopPropagation()
                        audio.playSFX('button')
                        setPopup('intro')
                    }}>
                        <QuestionMarkCircleIcon className="fill-main-600 w-6" />
                    </div> */}
                </div>
                <div className="flex-center gap-4">
                    <div className="w-full h-[0.625rem] bg-main-100 rounded-full">
                        <div
                            className="h-full bg-main rounded-full"
                            style={{
                                width: `${records.length / user.attraction_cards.length * 100}%`
                            }}
                        ></div>
                    </div>
                    <div className="text-main-600 font-bold font-gotham">
                        {Math.round(records.length / user.attraction_cards.length * 100)}%
                    </div>
                </div>
                <div className="flex-center justify-between">
                    <div className="text-black/60 font-medium flex-center gap-2">
                        目前共搜集
                        <span className="text-[1.375rem] text-main-600 font-bold font-gotham">
                            {user.attraction_cards.filter((c: any) => c.created_at).length} 張
                        </span>
                        景點卡
                    </div>
                    <div className="flex-center gap-0.5 text-secondary-500 font-bold">
                        查看護照
                        <ArrowUpRightIcon className="fill-secondary-500 stroke-[0.25px] stroke-secondary-500 w-6 -mt-0.5" />
                    </div>
                </div>
            </Button>
            {/* { popup === 'intro' &&
                <Intro setPopup={setPopup} />
            } */}
        </div>
    )
}